module.exports = __webpack_public_path__ + "img/icon_5_0.d55dfc0b.png";